
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ScheduleHeader extends Vue {
    @Prop({required: true})
    scheduleNumber!: string;

    @Prop({required: true})
    scheduleTitle!: string;

    @Prop({required: true})
    scheduleDescription!: string;
}
